import React from "react";

const TermosCondicoes = () => {
  return (
    <div
      style={{
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "40px",
        fontFamily: "'Poppins', sans-serif",
        lineHeight: "1.6",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#111",
          padding: "30px",
          borderRadius: "8px",
          border: "1px solid #444",
        }}
      >
        <h1 style={{ borderBottom: "2px solid #fff", paddingBottom: "10px" }}>
          Termos e Condições
        </h1>

        <p>
          Ao acessar e utilizar este site, você concorda com os seguintes
          termos e condições. Caso não concorde com algum deles, solicitamos
          que não utilize nosso site.
        </p>

        <h2>1. Uso do Site</h2>
        <p>
          O conteúdo deste site é destinado a fornecer informações sobre nossos
          serviços e produtos. Você concorda em utilizá-lo de maneira legal e
          ética, sem violar direitos de terceiros.
        </p>

        <h2>2. Propriedade Intelectual</h2>
        <p>
          Todo o conteúdo, imagens, textos, logos e marcas presentes no site
          são de propriedade da RetroFlex Gym ou de seus parceiros e estão
          protegidos por leis de direitos autorais.
        </p>

        <h2>3. Responsabilidade</h2>
        <p>
          A RetroFlex Gym não se responsabiliza por quaisquer danos ou perdas
          decorrentes do uso do site ou de informações nele contidas. O uso do
          site é de responsabilidade exclusiva do usuário.
        </p>

        <h2>4. Alterações nos Termos</h2>
        <p>
          Reservamo-nos o direito de modificar estes termos a qualquer momento.
          As alterações serão publicadas nesta página, e o uso contínuo do site
          implica aceitação dos novos termos.
        </p>

        <h2>5. Contato</h2>
        <p>
          Para dúvidas sobre estes termos, entre em contato através dos canais
          disponíveis no site.
        </p>

        <p style={{ marginTop: "20px", fontSize: "14px", color: "#ccc" }}>
          Última atualização: 14 de Agosto de 2025
        </p>
      </div>
    </div>
  );
};

export default TermosCondicoes;
